<app-radio-paginated [searchSettings]="searchSettings"
                     [loaderId]="loaderId"
                     [totalCount]="totalCount"
                     [filter]="filter"
                     [dataToView]="dataToView"
                     (search)="onSearch($event)"
                     (nextData)="getNextData($event)">
</app-radio-paginated>